function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.6 10.182V7.455C5.597 4.657 7.715 2.309 10.1 2c3.181-.254 5.725 1.622 6.3 4.545.081.314-.236.794-.9.91-.318.083-.797-.234-.9-.91-.368-1.645-2.064-2.897-3.6-2.727-2.175.206-3.587 1.77-3.6 3.637v2.727h9.9c1.491 0 2.7 1.22 2.7 2.727v6.364C20 20.779 18.791 22 17.3 22H4.7C3.209 22 2 20.779 2 19.273v-6.364c0-1.506 1.209-2.727 2.7-2.727h.9zM4.7 12c-.497 0-.9.407-.9.91v6.363c0 .502.403.909.9.909h12.6c.497 0 .9-.407.9-.91V12.91a.905.905 0 00-.9-.909H4.7z"
});

var SvgUnlock = function SvgUnlock(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/unlock.302ea4fa.svg";
export { SvgUnlock as ReactComponent };